//@flow
import React, { PureComponent } from 'react';
import Dimensions from './Dimensions';
import { Dimensions as DimensionsModel } from 'common/models/internal/Dimensions';
import type { MasterVehicleModel } from 'common/models/flow/MasterVehicleModel';
import type { TFunction } from 'react-i18next';
import { VolumeUnitEnum } from 'common/enums/VolumeUnitEnum';
import Units from 'common/enums/UnitEnum';

type Props = {
    field: Object,
    theme: Object,
    onChange: ?(entity: MasterVehicleModel) => void,
    entity: MasterVehicleModel,
    t: TFunction
};

class VehicleCapacity extends PureComponent<Props> {
    onChange = (index: number, volume: Object) => {
        const { onChange, entity } = this.props;
        onChange?.(entity.setVolume(volume));
    };

    onDimensionsChange = (
        index: number,
        containerDimensions: DimensionsModel
    ) => {
        const { onChange, entity } = this.props;
        let updatedEntity = entity;
        if (
            !containerDimensions.hasValidationErrors() &&
            containerDimensions.isFilled()
        ) {
            const { volume } = entity;
            const { unit: volumeUnit } = volume;
            updatedEntity = entity.setContainerDimensions(containerDimensions);
            if (volumeUnit === VolumeUnitEnum.MetersCubic) {
                const updatedVolume = volume.setValue(
                    containerDimensions.getTotalVolume()
                );
                updatedEntity = updatedEntity.setVolume(updatedVolume);
            }
        }
        updatedEntity = updatedEntity.setContainerDimensions(
            containerDimensions
        );
        onChange?.(updatedEntity);
    };

    render() {
        const { entity, field, t, theme, unitConverter } = this.props;
        const { volume, containerDimensions } = entity;
        const { unit: volumeUnit } = volume;
        return (
            <Dimensions
                t={t}
                error={field.validationMessage}
                theme={theme}
                volume={volume}
                dimensions={containerDimensions}
                onChange={this.onChange}
                onDimensionsChange={this.onDimensionsChange}
                volumeUnit={volumeUnit}
                unitConverter={unitConverter}
                distanceUnit={Units.list.length.Meter}
                preferredVolumeUnit={Units.list.volume.CubicMeter}
            />
        );
    }
}

export default VehicleCapacity;
